export enum JobTypes {
  BLAST = 'blast',
  ALIGN = 'align',
  ID_MAPPING = 'id mapping',
  PEPTIDE_SEARCH = 'peptide search',
  ASYNC_DOWNLOAD = 'file generation',
}
